(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/enetpulse-eventstats-widget/assets/javascripts/enetpulse-eventstats-widget.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/enetpulse-eventstats-widget/assets/javascripts/enetpulse-eventstats-widget.js');
"use strict";

function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }

const {
  WIDGET_TAG
} = svs.oddset_kambi.components.kambiWidgetUtils.constants;
var _eventId = new WeakMap();
var _isLive = new WeakMap();
class EnetpulseEventStatistics extends HTMLElement {
  constructor() {
    super(...arguments);
    _classPrivateFieldInitSpec(this, _eventId, void 0);
    _classPrivateFieldInitSpec(this, _isLive, void 0);
  }
  set eventId(value) {
    _classPrivateFieldSet(_eventId, this, value);
  }
  get eventId() {
    return _classPrivateFieldGet(_eventId, this);
  }
  set isLive(value) {
    _classPrivateFieldSet(_isLive, this, value);
  }
  get isLive() {
    return _classPrivateFieldGet(_isLive, this);
  }
  connectedCallback() {
    if (!this.eventId || !this.isLive) {
      return;
    }
    const iframe = document.createElement('iframe');
    iframe.title = 'Live Match Statistik';
    iframe.style.width = '100%';
    iframe.style.border = '0';
    iframe.src = "".concat(window.location.origin).concat(svs.core.urlMapping.get('oddsetHome'), "/enetpulse/widgets/eventstats/").concat(this.eventId);
    this.append(iframe);
    iframe.onload = () => {
      iframeResize({
        license: '12ajjdewwwy-26rnhw2943-1s7g1u8ma0i',
        waitForLoad: false
      }, iframe);
    };
  }
}
customElements.define(WIDGET_TAG.enetpulseEventStats, EnetpulseEventStatistics);

 })(window);